import { render, staticRenderFns } from "./payFeeBatchList.vue?vue&type=template&id=61b63d94&scoped=true"
import script from "./payFeeBatchList.vue?vue&type=script&lang=js"
export * from "./payFeeBatchList.vue?vue&type=script&lang=js"
import style0 from "./payFeeBatchList.vue?vue&type=style&index=0&id=61b63d94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b63d94",
  null
  
)

export default component.exports